import React from 'react';
import { Table } from 'semantic-ui-react';
import { membersToAddChange } from '../helper';
import MembersTableHeaderAddRow from './MembersTableHeaderAddRow';
import MembersDropdown from './MembersDropdown';
import MemberPermissionsDropdown from './MemberPermissionsDropdown';

const MembersPermissionAddRow = ({
  addMembers,
  allowSecure,
  entity,
  filter,
  members,
  membersToAdd,
  onFilterChange,
  permission,
  permissionGroups,
  readStatus,
  updateProperties,
}) => (
  <MembersTableHeaderAddRow
    colSpan={allowSecure ? 3 : 4}
    entity={`${entity}.member`}
    disabled={membersToAdd.length === 0}
    onClick={addMembers}
    extraContent={
      allowSecure && (
        <Table.HeaderCell collapsing className="top-33 z-10 w-30">
          <MemberPermissionsDropdown
            entity={entity}
            onChange={(value) => updateProperties({ permissionGroup: value })}
            permission={permission}
            permissionGroups={permissionGroups}
          />
        </Table.HeaderCell>
      )
    }
  >
    <MembersDropdown
      autoFocus
      filter={filter}
      members={members}
      onChange={(value) => updateProperties({ membersToAdd: membersToAddChange(members, value) })}
      onFilterChange={onFilterChange}
      readStatus={readStatus}
      text={membersToAdd.map((member) => (member.uuid ? member.uuid : member.code))}
    />
  </MembersTableHeaderAddRow>
);

export default MembersPermissionAddRow;
